class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    super.connectedCallback?.();

    // Run after DOM is ready inside header menu
    requestAnimationFrame(() => {
      this.initMegaMenuLevel2();
    });
  }

  initMegaMenuLevel2() {
    // Scope JS only inside this header-menu
    const level2Links = this.querySelectorAll('.mega-menu__link--level-2.has_items');

    if (!level2Links.length) return;

    const clearActive = () => {
      level2Links.forEach(link => {
        link.classList.remove('is-active');

        const submenu = link.nextElementSibling;
        if (submenu && submenu.classList.contains('list-unstyled')) {
          submenu.classList.remove('is-active');
        }
      });
    };

    // 🔹 Default active (first item)
    clearActive();
    const firstLink = level2Links[0];
    firstLink.classList.add('is-active');

    if (firstLink.nextElementSibling?.classList.contains('list-unstyled')) {
      firstLink.nextElementSibling.classList.add('is-active');
    }

    // 🔹 Hover behavior
    level2Links.forEach(link => {
      link.addEventListener('mouseenter', () => {
        console.log("here");
        clearActive();
        link.classList.add('is-active');

        const submenu = link.nextElementSibling;
        if (submenu && submenu.classList.contains('list-unstyled')) {
          submenu.classList.add('is-active');
        }
      });
    });
  }

  onToggle() {
    if (!this.header) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    )
      return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
